'use client'
import { RootState } from '@/app/globalRedux/store'
import {
  handleAdIntersection,
  useIntersectionObserver,
} from '@/app/hooks/useIntersectionObserver'
import { AdBannerScheduleType } from '@/app/types/adType'
import { handleAdClick } from '@/app/utils/AdsUtility'
import { useNavigation } from '@/app/utils/navigation'
import Image from 'next/image'
import { useParams, usePathname } from 'next/navigation'
import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

const InBetweenAds = ({
  adsData,
  index,
}: {
  adsData: AdBannerScheduleType
  index: number
}) => {
  const pathName = usePathname()
  const { redirectToAdvertise } = useNavigation()
  const localeLangauge = useSelector(
    (state: RootState) => state.user.localeLangauge
  )
  const params = useParams<{ lng: string }>()
  const listingPages = ['buyers-listing', 'sales-listing', 'news', 'events']
  const isRetails = pathName.includes('retails')

  const isListingPage = () => {
    const path = pathName.split('/')
    if (path.some((item) => listingPages.includes(item)) && !isRetails) {
      return 'Ad1 626x150.png'
    }
    return 'Ad1 626x300.png'
  }

  const searchResult: {
    [key: number]: string
  }[] = [
    {
      0: `/assets/image/FructidorAds/${localeLangauge}/SearchResultsAds/${isListingPage()}`,
    },
    {
      1: `/assets/image/FructidorAds/${localeLangauge}/SearchResultsAds/Ad2 626x150.png`,
    },
    {
      2: `/assets/image/FructidorAds/${localeLangauge}/SearchResultsAds/Ad3 626x150.png`,
    },
  ]
  const getAds = (key: number) => {
    const result: {
      [key: number]: string
    } =
      searchResult.find((searchResult) => key in searchResult) ??
      searchResult[0]
    return result ? result[key] : result[1][1]
  }
  const searchResultsTab = [
    'product-company-tab',
    'company-tab',
    'product-tab',
    'news-tab',
  ]
  const [isSearchResults, setIsSearchResults] = useState<boolean>(false)
  useEffect(() => {
    const value = pathName
      .split('/')
      ?.some((item) => searchResultsTab.includes(item))
    setIsSearchResults(value)
  }, [])
  const adPositionOneRef = useRef<HTMLDivElement>(null)

  const observeElement = useIntersectionObserver(handleAdIntersection)
  useEffect(() => {
    if (adPositionOneRef.current) {
      observeElement(adPositionOneRef.current)
    }
  }, [adPositionOneRef, observeElement])

  return (
    <div
      className={`ad_banner_gtm w-full top h-[${(isSearchResults || isRetails) && (index + 1) / 3 - 1 == 0 ? 300 : 150}px] text-center flex relative cursor-pointer`}
      ref={adPositionOneRef}
      data-ad-position={adsData?.ad_position?.name}
      data-ad-id={adsData?.ad_banner?.id}
      data-ad-sid={adsData?.id}
      data-ad-page={adsData?.page?.name}
      data-ad-company-id={adsData?.ad_banner?.company?.id}
      data-ad-lang={params?.lng}
    >
      <Image
        priority
        width={626}
        height={
          (isSearchResults || isRetails) && (index + 1) / 3 - 1 == 0 ? 300 : 150
        }
        src={adsData?.ad_banner?.image ?? getAds((index + 1) / 3 - 1)}
        alt=""
        id="ad_click"
        className={` w-full !h-[${
          (isSearchResults || isRetails) && (index + 1) / 3 - 1 == 0 ? 300 : 150
        }px] `}
        onClick={() => {
          if (adsData?.ad_banner?.image) {
            handleAdClick(adsData, params?.lng)
          } else {
            redirectToAdvertise()
          }
        }}
      />
    </div>
  )
}

export default InBetweenAds
